// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2BPRg","col":"styles_col__Wd-2d","fulfillmentStatus":"styles_fulfillmentStatus__1PJcn","emailCol":"styles_emailCol__1CgAd"};